import { Button } from '@chakra-ui/react';
import TabAttention from './TabAttention';

const ExternalLinkButton = ({
  children,
  target, // Extract target to set a default conditionally
  ...buttonProps
}) => {
  const { handleExternalLink } = TabAttention({});

  const handleClick = (e) => {
    // Start the animation
    handleExternalLink();
    
    // If this is an anchor tag, let it handle the navigation
    if (buttonProps.as === 'a') {
      // The link will handle navigation automatically
      return;
    }
    
    // For other button types, prevent default and handle manually if needed
    e.preventDefault();
  };

  return (
    <Button
      onClick={handleClick}
      target={buttonProps.as === 'a' && target === undefined ? '_blank' : target} // Default to _blank for <a> if not specified
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export default ExternalLinkButton;